<div class="custom-input-widget" tabindex="1">
    <div *ngIf="iconClass">
        <button [attr.data-automation-id]="automationId + '-icon-button'" (click)="openGenericTargetPicker()"
            [disabled]="isFieldDisabled" class="input-icon-button" [tabindex]="excludeTrashBtnFromTabIndex ? -1 : 0">
            <i class="fa" [ngClass]="[iconClass ? iconClass : '', iconColor ? iconColor : '']"></i>
        </button>
    </div>
    <div [ngClass]="[customWidth ? '' : 'full-width']">
        <input class="form-control input-control" [attr.data-automation-id]="automationId + '-input'" id="automationId"
            autocomplete="off" [ngClass]="[hasFilterValue() ? 'filteredInput': '' ]"
            [ngStyle]="{'width':customWidth ? customWidth : '100%', 'padding-right': hideClearBtn ? '0px' : '32px'}"
            (focusout)="onFocusOut(field)" [(ngModel)]="field.value" [disabled]="isFieldDisabled"
            (ngModelChange)="queryFocusChange()" type="{{inputType}}" placeholder="{{placeholderField}}"
            id="{{automationId}}_input" (keypress)="onKeypressEvent($event)" />

    </div>
    <div *ngIf="hasValue(field) && !isFieldDisabled">
        <button [attr.data-automation-id]="automationId + '-clear-button'" (click)="field.value = '';queryFocusChange()"
            class="text-clear-button" [tabindex]="excludeTrashBtnFromTabIndex ? -1 : 0">
            <i class="fa fa-times"></i>
        </button>
    </div>

</div>